import React, { FC, useState } from 'react';
import { CustomModal } from 'components/uikit/modal/CustomModal.tsx';
import { Button, ButtonColor } from 'components/uikit/buttons/Button.tsx';
import { QueryFactory } from 'services/api';
import styles from './CancelDocumentSigningModal.module.scss';
import { Field } from 'components/uikit/Field.tsx';
import { Input } from 'components/uikit/inputs/Input.tsx';
import { useScopedTranslation } from 'application/localization/useScopedTranslation.ts';
import { Trans } from 'react-i18next';
import { useSignatureBlockQueriesInvalidation } from '../signatureBlock/useSignatureBlockQueriesInvalidation.tsx';

export type CancelDocumentSigningModalProps = {
  documentId: number;
  revisionId: number;
  projectId: number;
  isOpen: boolean;
  onClose: () => void;
};

export const CancelDocumentSigningModal: FC<CancelDocumentSigningModalProps> = (
  props,
) => {
  const i18n = useScopedTranslation('Component.CancelDocumentSigningModal');
  const buttonTitle = useScopedTranslation('Button.Title');
  const [confirmDocumentName, setConfirmDocumentName] = useState('');
  const documentQuery = QueryFactory.DocumentQuery.useGetQuery(
    props.documentId,
    {
      enabled: !!props.documentId && props.isOpen,
    },
  );
  const invalidateSignatureBlockQueries = useSignatureBlockQueriesInvalidation({
    revisionId: props.revisionId,
  });

  const isDeleteDisabled = confirmDocumentName !== documentQuery.data?.name;

  const onClose = () => {
    setConfirmDocumentName('');
    props.onClose();
  };

  return (
    <CustomModal
      isOpen={props.isOpen}
      onClose={onClose}
      isBlocking={true}
      title={i18n.t('title')}
    >
      <div className={styles.message}>
        <Trans
          i18nKey={'Component.CancelDocumentSigningModal.message'}
          values={{ name: documentQuery.data?.name }}
          components={{
            red: <span className={styles.danger} />,
            pre: <span className={styles.noWhiteSpace} />,
            p: <p />,
          }}
        />
        <Field className={styles.confirmField} title={i18n.t('confirm_field')}>
          <Input
            value={confirmDocumentName}
            onChange={(e) => {
              setConfirmDocumentName(e.target.value);
            }}
          ></Input>
        </Field>
      </div>
      <div className={styles.footer}>
        <Button
          title={buttonTitle.t('cancel')}
          color={ButtonColor.Secondary}
          className={styles.button}
          onClick={onClose}
        />
        <Button
          testId={'confirm-button'}
          title={buttonTitle.t('confirm')}
          color={ButtonColor.DestroyPrimary}
          className={styles.button}
          disabled={isDeleteDisabled}
          onClick={async () => {
            await QueryFactory.DocumentSigningClient.stopDocumentSigning(
              props.documentId,
            );
            await invalidateSignatureBlockQueries();
            onClose();
          }}
        />
      </div>
    </CustomModal>
  );
};
